(() => {
  const configNode = document.getElementById('mb-ai-config');
  if (!configNode || window.mbAiDisclosure) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const list = value => String(value || '').split(',').map(item => item.trim()).filter(Boolean);
  const excludedUrls = list(config.excluded_urls);
  const disabledContexts = new Set(list(config.disabled_contexts));
  const excluded = '[data-mb-ai-exempt],.header__heading,.header__heading-link,.mb-logo,.mb-footer-brand,.footer__content-bottom,.list-payment,.payment-icons,.shopify-payment-button,.icon-with-text,.svg-wrapper,.mb-native-photos,.mb-native-review,[data-review-photo],.jdgm-widget,.loox-reviews-default,.shopify-app-block,.swatch,.swatch-input__label,.facets__image,.product-form__input,.product-disclosures,.cart-disclosure-indicator,.disclosures__icon,.disclosures-summary-item,.disclosures-item,.cart-item__disclosure-tooltip-symbol,.cart-item__disclosure-dialog-symbol,.trust-badge,.trust-seal,[data-payment-logo],[data-brand-logo],[data-trust-seal]';
  let customExcluded = config.excluded_selectors;
  if (customExcluded) { try { document.querySelector(customExcluded); } catch { customExcluded = ''; } }
  const roots = '#MainContent,main,cart-drawer,cart-notification,.predictive-search,.mb-predictive-search,.shopify-policy__container,product-modal,.mb-gallery-zoom-dialog';
  const mediaSelector = 'img,video,iframe[src*="youtube"],iframe[src*="vimeo"],[data-mb-ai-background],[style*="background-image"]';
  const knownHost = '.mb-ai-media,.mb-ai-inline-media,.mb-reference-tile,deferred-media,.mb-brand-film__frame,.mb-product-media,.mb-gallery-main,.mb-gallery-zoom-image,.mb-thumbnails>a,.mb-card-visual,.mb-reference-category-image,.mb-reference-tile-product,.mb-product-aplus__media,.mb-product-aplus__image,.mb-guide-card__media,.mb-reference-feature-image,.mb-hero-image,.card__media,.card__inner>.media,.article-card__image,.cart-item__media,.cart-notification-product__image,.thumbnail,.banner__media,.slideshow__media,.image-with-text__media,.collage-card,.multicolumn-card__image-wrapper,.predictive-search__image,.mb-predictive-search__image,.product__media,.product-media-container,.media';
  const sources = medium => [medium.getAttribute('src'), medium.getAttribute('poster'), medium.getAttribute('style'), medium.getAttribute('data-mb-ai-background'), ...Array.from(medium.querySelectorAll?.('source') || [], source => source.getAttribute('src') || source.getAttribute('data-film-src'))].filter(Boolean);
  const exempt = medium => medium.closest(excluded) || (customExcluded && medium.closest(customExcluded)) || sources(medium).some(source => excludedUrls.some(fragment => source.includes(fragment))) || sources(medium).some(source => /(?:\/|^)mb-logo-original(?:_[\dx]+)?\.png(?:\?|$)/i.test(source));
  const owned = medium => medium.tagName !== 'IMG' || sources(medium).some(source => {
    try { const url = new URL(source, location.href); return !/\.svg(?:\?|$)/i.test(url.pathname) && (url.origin === location.origin || url.hostname === 'cdn.shopify.com' || url.hostname.endsWith('.myshopify.com')); } catch { return false; }
  });
  function contextFor(medium, kind) {
    if (medium.closest('cart-drawer,cart-notification,.cart-item')) return 'cart';
    if (medium.closest('.mb-gallery,media-gallery,product-modal,.mb-gallery-zoom-dialog')) return 'gallery';
    if (medium.closest('.card,.mb-product-card,.predictive-search,.mb-predictive-search')) return 'card';
    return kind === 'video' ? 'video' : 'editorial';
  }
  function label(host, kind, context, medium) {
    const labels = Array.from(host.children).filter(child => child.hasAttribute('data-mb-ai-label'));
    const allowed = !disabledContexts.has(context) && (kind === 'video' ? config.videos : config.images) && !exempt(medium);
    labels.forEach((item, index) => { item.hidden = !allowed; if (index) item.remove(); });
    if (!allowed) return;
    host.classList.add('mb-ai-media');
    host.dataset.mbAiKind = kind;
    host.dataset.mbAiContext = context;
    const item = labels[0] || document.createElement('span');
    item.className = 'mb-ai-label';
    item.dataset.mbAiLabel = kind;
    item.dataset.mbAiContext = context;
    item.textContent = config[kind] || config.image;
    if (!item.parentNode) host.append(item);
    if (kind === 'video') fullscreen(host);
  }
  function fullscreen(host) {
    if (!host.requestFullscreen || host.querySelector(':scope > .mb-ai-fullscreen')) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'mb-ai-fullscreen';
    button.textContent = '⛶';
    button.setAttribute('aria-label', config.fullscreen);
    button.title = config.fullscreen;
    button.addEventListener('click', async () => {
      try { if (document.fullscreenElement === host) await document.exitFullscreen(); else await host.requestFullscreen(); } catch { button.hidden = true; }
    });
    document.addEventListener('fullscreenchange', () => { const title = document.fullscreenElement === host ? config.exit_fullscreen : config.fullscreen; button.setAttribute('aria-label', title); button.title = title; });
    host.append(button);
  }
  function process(medium) {
    if (!medium.closest(roots) || medium.closest('template,video,svg') && medium.tagName === 'IMG') return;
    let host = medium.closest('.mb-ai-media,.mb-ai-inline-media') || medium.closest(knownHost);
    if (host === medium && medium.tagName === 'IMG') host = null;
    if (exempt(medium) || !owned(medium)) {
      if (host) Array.from(host.children).filter(child => child.hasAttribute('data-mb-ai-label')).forEach(child => { child.hidden = true; });
      return;
    }
    const initialLabel = Array.from(host?.children || []).find(child => child.hasAttribute('data-mb-ai-label'));
    const isVideo = initialLabel?.dataset.mbAiLabel === 'video' || medium.tagName === 'VIDEO' || medium.tagName === 'IFRAME' || host?.dataset.mbAiKind === 'video' || host?.matches('deferred-media,.mb-brand-film__frame');
    const kind = isVideo ? 'video' : host?.dataset.mbAiKind || initialLabel?.dataset.mbAiLabel || (medium.closest('.mb-gallery,media-gallery,product-modal,.mb-gallery-zoom-dialog') ? 'product' : 'image');
    const context = host?.dataset.mbAiContext || initialLabel?.dataset.mbAiContext || contextFor(medium, kind);
    if (!host) {
      const picture = medium.closest('picture');
      const target = picture || medium;
      if (medium.matches('[data-mb-ai-background],[style*="background-image"]')) host = medium;
      else {
        host = document.createElement('span');
        host.className = 'mb-ai-inline-media';
        target.before(host);
        host.append(target);
      }
    }
    label(host, kind, context, medium);
  }
  function scan(node) {
    if (!(node instanceof Element)) return;
    if (node.matches(mediaSelector)) process(node);
    node.querySelectorAll(mediaSelector).forEach(process);
  }
  const pending = new Set();
  let queued = false;
  const observer = new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') pending.add(record.target);
      else record.addedNodes.forEach(node => { if (node instanceof Element && !node.matches('.mb-ai-label,.mb-ai-fullscreen')) pending.add(node); });
    }
    if (queued || !pending.size) return;
    queued = true;
    queueMicrotask(() => { queued = false; const nodes = [...pending]; pending.clear(); nodes.filter(node => node.isConnected).forEach(scan); });
  });
  document.querySelectorAll(roots).forEach(scan);
  observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['src','srcset','style','data-mb-ai-exempt'] });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.mbAiDisclosure = { scan };
})();
